import { OtherDetails as TypeOtherDetails } from "pages/GenericOrderDetailsPage/types/order";
import { useNavigate } from "react-router-dom";

export default function OtherDetails({
    orderdetails,
}: {
    orderdetails: TypeOtherDetails;
}) {
    const navigate = useNavigate();

    const handleLeadRedirect = (event: any, lead: string) => {
        event.preventDefault();
        navigate(`/forex/leads`, {
            state: {
                LeadID: lead,
                leadModalState: true,
            },
        });
    };
    return (
        <div>
            {/* <div className="grid grid-cols-2 gap-8 w-full">
                <div className="w-full flex flex-col flex-grow gap-2">
                    <h5 className="text-[#999999] leading-4 font-medium text-base">
                        Remitter Details
                    </h5>
                    <div className="rounded-lg bg-[#FBFBFB] flex flex-col justify-between w-full p-2">
                        <div className="flex flex-row gap-2 items-center">
                            <h1>{orderdetails?._order_customers?.full_name}</h1>
                        </div>
                        <div className="flex text-gray-400 items-center gap-2">
                            <h1>Email:</h1>
                            <span className={valueStyle} style={{ color: "gray" }}>
                                {orderdetails?._order_customers?.email}
                            </span>
                        </div>
                        <div className="flex text-gray-400 items-center gap-2">
                            <h1>Mobile:</h1>
                            <span className={valueStyle} style={{ color: "gray" }}>
                                {orderdetails?._order_customers?.phone_number
                                    ? orderdetails?._order_customers?.phone_number
                                    : " N/A"}
                            </span>
                        </div>
                    </div>
                </div>
                {studentName?.value && (
                    <div className="w-full flex flex-col flex-grow gap-2">
                        <h5 className="text-[#999999] leading-4 font-medium text-base">
                            Student details
                        </h5>
                        <div className="flex gap-5 p-5 flex-col rounded-xl border border-white-A700 shadow-[1px_1px_7px_0px_rgba(34,82,167,0.1)]">
                            <div className="rounded-lg bg-[#FBFBFB] flex flex-col justify-between w-full">
                                <div className="flex text-gray-400 item-center gap-2">
                                    <h1 className="font-medium text-base leading-[25.6px] text-black-label">
                                        {studentName?.value || "N/A"}
                                    </h1>
                                </div>
                                <div className="flex text-gray-400 item-center gap-2">
                                    <h1>Passport:</h1>
                                    <span
                                        className={valueStyle}
                                        style={{ color: "gray" }}
                                    >
                                        {orderdetails?._order_service_partner
                                            .passport_no || "N/A"}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div> */}
            {/* <div className="w-full flex flex-col flex-grow gap-5 my-8">
                <h5 className="text-[#999999] leading-4 font-medium text-base">
                    Beneficiary details
                </h5>
                <div className="flex gap-4 p-5 flex-col rounded-xl bg-[#FBFBFB]">
                    <div className="rounded-lg  flex flex-col justify-between w-full gap-3">
                        <div className="flex flex-row gap-2 items-center">
                            <h1 className="font-medium text-base leading-[25.6px] text-black-label">
                                {orderdetails?._beneficiary?.name || "N/A"}
                            </h1>
                        </div>
                        <div className="flex text-gray-400 item-center gap-4">
                            <h1>Bank name:</h1>
                            <span className={valueStyle}>
                                {orderdetails?._beneficiary?.bank_name}
                            </span>
                        </div>
                        <div className="flex text-gray-400 item-center gap-4">
                            <h1>Account number / IBAN:</h1>
                            {(orderdetails?._beneficiary?.account_number ||
                                orderdetails?._beneficiary?.iban_no) && (
                                    <span className={valueStyle}>
                                        {orderdetails?._beneficiary?.account_number ||
                                            orderdetails?._beneficiary?.iban_no}
                                    </span>
                                )}
                        </div>
                        <div className="flex text-gray-400 item-center gap-4">
                            <h1>SWIFT Code:</h1>
                            <span className={valueStyle}>
                                {orderdetails?._beneficiary?.swift_code || "N/A"}
                            </span>
                        </div>
                        <div className="flex text-gray-400 item-center gap-4">
                            <h1>Reference number:</h1>
                            <span className={valueStyle}>
                                {orderdetails?.reference_no || "N/A"}
                            </span>
                        </div>
                        <div className="flex text-gray-400 item-center gap-4">
                              <h1>Correspondent bank name :</h1>
                              <span className={valueStyle}>
                                {orderdetails?._beneficiary?.correspondant_bank_name ||
                                  "N/A"}
                              </span>
                            </div>
                            <div className="flex text-gray-400 item-center gap-4">
                              <h1>Correspondent bank number :</h1>
                              <span className={valueStyle}>
                                {orderdetails?._beneficiary?.correspondant_bank_no ||
                                  "N/A"}
                              </span>
                            </div>
                        <div className="flex text-gray-400 item-center gap-4">
                            <h1>Bank Address:</h1>
                            <span className={valueStyle}>
                                {orderdetails?._beneficiary?.bank_addr || "N/A"}
                            </span>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* partner details */}
            {/* {channelDetails?.id === 12 && !checkLevel(LEVEL_2) && (
                <div className="w-full flex flex-col flex-grow gap-5 my-8">
                    <h5 className="text-[#999999] leading-4 font-medium text-base">
                        Partner Details
                    </h5>
                    <div className="flex gap-5 p-5 bg-[#FBFBFB] flex-col rounded-xl border border-white-A700">
                        <div className="rounded-lg flex flex-col justify-between w-full gap-3">
                            <div className="flex flex-row gap-2 items-center">
                                <span
                                    className="bg-[#EFF4FF] text-black-200 rounded-lg p-2"
                                    style={{ fontWeight: "400" }}
                                >
                                    {orderdetails?.partner_detail?.type.toUpperCase()}
                                </span>
                                <h1 className="font-medium text-base leading-[25.6px] text-black-label">
                                    {orderdetails?.partner_detail?.name || "N/A"}
                                </h1>
                            </div>
                            <div className="flex gap-2">
                                <p className={labelStyle}>
                                    Partner Trade:{" "}
                                    <span className={valueStyle}>
                                        {orderdetails?.partner_detail?.type || "N/A"}
                                    </span>
                                </p>
                            </div>
                            <div className="flex gap-2">
                                <p className={labelStyle}>
                                    Branch Location:{" "}
                                    <span className={valueStyle}>
                                        {orderdetails?.partner_detail?.city || "N/A"},{" "}
                                        {orderdetails?.partner_detail?.state || "N/A"}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )} */}

            {/* Service provider details */}
            {/* {!checkLevel(LEVEL_2) && (
                <div className="w-full flex flex-col flex-grow gap-5 my-8">
                    <h5 className="text-[#999999] leading-4 font-medium text-base">
                        Service provider details
                    </h5>
                    <div className="flex gap-5 p-5 bg-[#FBFBFB] flex-col rounded-xl border border-white-A700">
                        <div className="rounded-lg flex flex-col justify-between w-full gap-3">
                            <div className="flex flex-row gap-2 items-center">
                                <h1 className="font-medium text-base leading-[25.6px] text-black-label">
                                    {orderdetails?._order_service_partner?.display_name}
                                </h1>
                            </div>
                            <div className="flex gap-2">
                                <p className={labelStyle}>
                                    Email:{" "}
                                    <span className={valueStyle}>
                                        {orderdetails?._order_service_partner?.email}
                                    </span>
                                </p>
                            </div>
                            <div className="flex gap-2">
                                <p className={labelStyle}>
                                    Service ID:{" "}
                                    <span className={valueStyle}>
                                        {orderdetails?._order_service_partner?.id}
                                    </span>
                                </p>
                            </div>
                            <div className="flex gap-2">
                                <p className={labelStyle}>
                                    Location:{" "}
                                    <span className={valueStyle}>
                                        {orderdetails?._order_service_partner
                                            ?.legal_addr_city &&
                                            orderdetails?._order_service_partner
                                                ?.legal_addr_state
                                            ? `${orderdetails?._order_service_partner?.legal_addr_city}, ${orderdetails?._order_service_partner?.legal_addr_state}`
                                            : orderdetails?._order_service_partner
                                                ?.legal_addr_city ||
                                            orderdetails?._order_service_partner
                                                ?.legal_addr_state ||
                                            "N/A"}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )} */}

            {/* <div className="w-full flex flex-col flex-grow gap-2"> */}
            {/* <h5>Partner Details</h5> */}
            {/* <div className="flex gap-5 p-5 flex-col rounded-xl border border-white-A700 shadow-[1px_1px_7px_0px_rgba(34,82,167,0.1)]"> */}
            {/* <div className="rounded-lg flex justify-between w-full">
                            <div className="flex gap-2">
                              <p className={labelStyle}>
                                Name: <span className={valueStyle}></span>
                              </p>
                            </div>
                            <div className="flex gap-2">
                              <p className={labelStyle}>
                                Parner ID: <span className={valueStyle}></span>
                              </p>
                            </div>
                          </div> */}

            <div className="rounded-lg p-2 bg-[#FFEAC9]">
                {
                    orderdetails?.lead_ids?.length > 0 ?
                        <h1 className="text-[#000]">
                            This order has been created from Lead ID{" "}
                            {(orderdetails?.lead_ids)?.map((lead) => {
                                return (
                                    <a
                                        // href={`/forex/leads`}
                                        onClick={(e) => handleLeadRedirect(e, lead)}
                                        className="text-blue-600 mr-1 underline cursor-pointer"
                                    >
                                        {lead}
                                    </a>
                                );
                            })}
                        </h1>
                        :
                        <h1 className="text-[#000]">No Lead associated with this order.</h1>
                }
            </div>
        </div>
    );
}
